import { Typography, TypographyProps } from '@mui/material'
import { StyledTableCell } from '../invoice-table-body'
import { InvoiceResponse } from 'store/invoices/invoices.types'
import { listPrimaryTextSx } from 'components/list-table/list-table.styles'

const InvoiceTableCompany = ({
  minWidth,
  align,

  customerName,
}: Partial<InvoiceResponse> & TypographyProps) => {
  return (
    <StyledTableCell sx={{ minWidth }} align={align}>
      <Typography sx={{ ...listPrimaryTextSx }} noWrap>
        {customerName}
      </Typography>
      {/* <Typography
        sx={{
          color: 'InfoText',
          fontWeight: 300,
        }}
      >
        {customerId}
      </Typography> */}
    </StyledTableCell>
  )
}

export default InvoiceTableCompany
